var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3315 17.4476H13.6595C14.0967 17.4476 14.516 17.6189 14.8251 17.9237C15.1343 18.2285 15.3079 18.6419 15.3079 19.0729V22.5893C15.3052 22.9625 15.4536 23.3213 15.7203 23.5862C15.9869 23.851 16.3498 24 16.7283 24H18.9988C20.0592 24.0027 21.0771 23.5893 21.8279 22.8509C22.5787 22.1126 23.0007 21.11 23.0007 20.0645V10.0469C23.0007 9.20232 22.621 8.40121 21.9639 7.85937L14.2401 1.77725C12.8965 0.710845 10.9714 0.745277 9.66797 1.85903",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6682 17.4476H10.3402C9.90302 17.4476 9.48373 17.6189 9.17459 17.9237C8.86544 18.2285 8.69177 18.6419 8.69177 19.0729V22.5893C8.69453 22.9625 8.54611 23.3213 8.27944 23.5862C8.01277 23.851 7.64992 24 7.27141 24H5.00091C3.9405 24.0027 2.92258 23.5893 2.17178 22.8509C1.42098 22.1126 0.999023 21.11 0.999023 20.0645V10.0469C0.999023 9.20232 1.37874 8.40121 2.03578 7.85937L9.75963 1.77725C11.1032 0.710845 13.0283 0.745277 14.3317 1.85903",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHomeIcon);
export default __webpack_public_path__ + "static/media/dashboard_home_icon.bf1fbf26823400a612dccdcd6341fb39.svg";
export { ForwardRef as ReactComponent };